import { HttpService } from '@/shared/services'
import LetterRequest from '../models/LetterRequest'
import List from '@/shared/dtos/List'
import ICreateLetterRequest from './dtos/ICreateLetterRequest'
import ICreateLetterResolution from './dtos/ICreateLetterResolution'
import PaginationInputDto from '@/shared/dtos/pagination'
import PaginatedResult from '@/shared/dtos/PaginatedResult'

const http = new HttpService()

export const getLetterRequestsByEmployee = async (
  employeeId: string,
  pagination: PaginationInputDto
) => {
  const response = await http.get<PaginatedResult<LetterRequest>>(
    `/letterRequests/employee/${employeeId}?search=${pagination.search}&limit=${pagination.limit}&offset=${pagination.offset}`
  )

  return response?.data
}

export const getLetterRequestsByApproverId = async (approverId: string) => {
  const response = await http.get<List<LetterRequest[]>>(
    `/letterRequests/approver/${approverId}`
  )
  return response.data
}

export const getLetterRequestsByConfigId = async (configId: string) => {
  const response = await http.get<List<LetterRequest[]>>(
    `/letterRequests/letterConfig/${configId}`
  )
  return response.data
}

export const createLetterRequest = async (
  letterRequestDto: ICreateLetterRequest
) => {
  const response = await http.post<ICreateLetterRequest, string>(
    '/letterRequests',
    letterRequestDto
  )
  return response.data
}

export const getLetterRequestDetail = async (letterRequestId: string) => {
  const response = await http.get<LetterRequest>(
    `/letterRequests/${letterRequestId}`
  )
  return response.data
}

export const createLetterRequestResolutions = async (
  dto: ICreateLetterResolution
) => {
  const response = await http.post<ICreateLetterResolution, string>(
    '/letterRequests/resolutions',
    dto
  )
  return response.data
}
